import React, { useState, useEffect, useRef } from 'react';
// import { appInsights, reactPlugin } from '../../../appInsights';
// import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { jsonEditorStyles } from '../jsonEditorStyles';
import cn from 'clsx';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import { SelectChangeEvent } from '@mui/material';
import { Box, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { getJSONAADAttributes, getNodeData } from '../../../store';
import { SelectComponent, TextComponent } from '../../uiComponents';
import { OptionProps } from '../../../view-models';
import jsonComponentsConfig from '../../../constants/jsonComponents';
import useComponentUIHook from './useComponentUIHook';
import SessionManagement, { sessionFieldsAreValid } from './sessionManagement';
import { cloneDeep } from 'lodash';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';

interface componentProps {
  componentData: any;
  closeGritComponent: any;
  setUnsavedChanges: any;
}

const GenerateAADReadUI = ({ componentData, closeGritComponent, setUnsavedChanges }: componentProps) => {
  const initAttribute = useRef(componentData['attribute']);
  const [selClaims, setSelClaims] = useState<string[]>([]);
  const [selattributes, setSelAttributes] = useState<string[]>([]);
  const configData = jsonComponentsConfig.aadRead.data;
  const { modifiedData, setModifiedData, checkIfSameIgnoringSubFlows, allClaims } = useComponentUIHook(componentData);
  const [disableSubmit, setDisableSubmit] = useState<boolean>(false);
  const [enableMapBt, setEnableMapBt] = useState(false);
  const allAADAttributes = useSelector(getJSONAADAttributes);
  const allNodeData = useSelector(getNodeData);
  const classes = jsonEditorStyles();

  useEffect(() => {
    const mapCA = allNodeData[componentData.id]?.attributes || [];
    setSelClaims(mapCA.map((m: any) => m.claim));
    setSelAttributes(mapCA.map((m: any) => m.id));
  }, [allNodeData]);

  useEffect(() => {
    const _res: boolean = checkIfSameIgnoringSubFlows();
    setDisableSubmit(_res || modifiedData?.indexProperty?.id === '' || modifiedData?.indexProperty?.claim === '' ||
    (!sessionFieldsAreValid(modifiedData)));
    setUnsavedChanges(_res);
    setEnableMapBt(modifiedData['attribute']['claim'] && modifiedData['attribute']['id']);
    setSelClaims(
      modifiedData?.indexProperty?.claim
        ? modifiedData?.attributes.map((m: any) => m.claim).concat([modifiedData?.indexProperty?.claim])
        : modifiedData?.attributes.map((m: any) => m.claim),
    );
    setSelAttributes(modifiedData?.attributes.map((m: any) => m.id));
  }, [modifiedData]);

  return (
    <div>
      <FormControl required sx={{ m: 1, minWidth: 600 }}>
        <div className={classes.flexRow}>
          <SelectComponent
            changeHandler={(e: SelectChangeEvent<string>) => {
              setModifiedData({
                ...modifiedData,
                ['indexProperty']: {
                  id: e.target.value,
                  dataType:
                    configData.indexProperty.dataTypes[
                      configData.indexProperty.values.findIndex((el: any) => el === e.target.value)
                    ],
                  claim: '',
                },
              });
            }}
            data={{
              value: modifiedData.indexProperty?.id || '',
              label: configData.indexProperty.displayName,
              options: configData.indexProperty.values.map((v) => ({ label: v, value: v })),
              style: { margin: 1, width: 200 },
              required: true,
            }}
          />
          <SelectComponent
            changeHandler={(e: SelectChangeEvent<string>) => {
              setSelClaims((prv) =>
                prv.find((p) => p === e.target.value)
                  ? prv
                  : prv.filter((i) => i !== modifiedData?.indexProperty?.claim).concat(e.target.value),
              );
              setModifiedData({
                ...modifiedData,
                ['indexProperty']: { ...modifiedData.indexProperty, claim: e.target.value },
              });
            }}
            data={{
              value: modifiedData?.indexProperty?.claim,
              label: 'Claim',
              style: { margin: 1, width: 200 },
              options: Object.keys(allClaims)
                .filter(
                  (c) =>
                    !selClaims.find((s) => s === c) && allClaims[c]?.dataType === modifiedData.indexProperty.dataType,
                )
                .reduce(
                  (acc: OptionProps[], curVal: string) => acc.concat({ label: curVal, value: curVal }),
                  modifiedData?.indexProperty?.claim
                    ? [
                        {
                          label: modifiedData?.indexProperty?.claim,
                          value: modifiedData?.indexProperty?.claim,
                        },
                      ]
                    : [],
                )
                .sort((a: OptionProps, b: OptionProps) => (a.value.toLowerCase() > b.value.toLowerCase() ? 1 : -1)),
              required: true,
            }}
          />
          <FormControlLabel
            sx={{ m: 0, width: '300px' }}
            label={configData.throwErrorIfNotFound.displayName}
            control={
              <Checkbox
                checked={modifiedData['throwErrorIfNotFound']}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  setModifiedData({
                    ...modifiedData,
                    throwErrorIfNotFound: !modifiedData['throwErrorIfNotFound'],
                  });
                }}
              />
            }
          />
        </div>
        <Box>
          <Typography gutterBottom variant="body1">
            Mapping of aad property to tenant attribute
          </Typography>
          <div>
            {modifiedData?.attributes.map((map: any, index: number) => {
              return (
                <div className={classes.flexRow} key={map.claim + map.id}>
                  <SelectComponent
                    changeHandler={(e: SelectChangeEvent<string>) => {
                      const _temp = cloneDeep(modifiedData);
                      _temp['attributes'][index]['id'] = e.target.value;
                      setModifiedData(_temp);
                    }}
                    data={{
                      value: map.id,
                      label: 'AAD Attribute',
                      required: true,
                      style: { margin: 1, width: 200 },
                      options: Object.keys(allAADAttributes)
                        .filter(
                          (a) =>
                            // !selattributes.find((s) => s === a) &&
                            allAADAttributes[a]?.dataType ===
                            (allClaims[map.claim]?.dataType || allAADAttributes[a]?.dataType),
                        )
                        .reduce(
                          (acc: OptionProps[], curVal: string) => acc.concat({ label: curVal, value: curVal }),
                          [],
                        )
                        .sort((a: OptionProps, b: OptionProps) =>
                          a.value.toLowerCase() > b.value.toLowerCase() ? 1 : -1,
                        ),
                    }}
                  />
                  <SelectComponent
                    changeHandler={(e: SelectChangeEvent<string>) => {
                      const _temp = cloneDeep(modifiedData);
                      _temp['attributes'][index]['claim'] = e.target.value;
                      setModifiedData(_temp);
                    }}
                    data={{
                      value: map.claim,
                      label: 'Claim',
                      required: true,
                      style: { margin: 1, width: 200 },
                      options: Object.keys(allClaims)
                        .filter(
                          (c) =>
                            !selClaims.find((s) => s === c) &&
                            (allAADAttributes[map.id].dataType || allClaims[c]?.dataType) === allClaims[c]?.dataType,
                        )
                        .reduce(
                          (acc: OptionProps[], curVal: string) => acc.concat({ label: curVal, value: curVal }),
                          [{ label: map.claim, value: map.claim }],
                        )
                        .sort((a: OptionProps, b: OptionProps) =>
                          a.value.toLowerCase() > b.value.toLowerCase() ? 1 : -1,
                        ),
                    }}
                  />
                  <div>
                    <Button
                      type="submit"
                      fullWidth
                      variant="contained"
                      sx={{ mt: 1, mb: 2 }}
                      onClick={() => {
                        const _temp = cloneDeep(modifiedData);
                        _temp['attributes'].splice(index, 1);
                        setModifiedData(_temp);
                      }}
                    >
                      Delete
                    </Button>
                  </div>
                </div>
              );
            })}
          </div>
          <div className={classes.flexRow}>
            <SelectComponent
              changeHandler={(e: SelectChangeEvent<string>) => {
                setModifiedData({ ...modifiedData, attribute: { ...modifiedData['attribute'], id: e.target.value } });
              }}
              data={{
                value: modifiedData?.attribute?.id,
                label: 'AAD Attribute',
                style: { margin: 1, width: 200 },
                options: Object.keys(allAADAttributes)
                  .filter((a) => {
                    const res =
                      // !selattributes.find((s) => s === a) &&
                      allAADAttributes[a]?.dataType ===
                      (allClaims[modifiedData?.attribute?.claim]?.dataType || allAADAttributes[a]?.dataType);
                    return res;
                  })
                  .reduce((acc: OptionProps[], curVal: string) => acc.concat({ label: curVal, value: curVal }), [])
                  .sort((a: OptionProps, b: OptionProps) => (a.value.toLowerCase() > b.value.toLowerCase() ? 1 : -1)),
              }}
            />
            <SelectComponent
              changeHandler={(e: SelectChangeEvent<string>) => {
                setModifiedData({
                  ...modifiedData,
                  attribute: { ...modifiedData['attribute'], claim: e.target.value },
                });
              }}
              data={{
                value: modifiedData?.attribute?.claim,
                label: 'Claim',
                style: { margin: 1, width: 200 },
                options: Object.keys(allClaims)
                  .filter(
                    (c) =>
                      !selClaims.find((s) => s === c) &&
                      (allAADAttributes[modifiedData?.attribute?.id]?.dataType || allClaims[c]?.dataType) ===
                        allClaims[c]?.dataType,
                  )
                  .reduce((acc: OptionProps[], curVal: string) => acc.concat({ label: curVal, value: curVal }), [])
                  .sort((a: OptionProps, b: OptionProps) => (a.value.toLowerCase() > b.value.toLowerCase() ? 1 : -1)),
              }}
            />
            <div>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 1, mb: 2 }}
                onClick={() => {
                  setModifiedData((prv: any) => ({
                    ...modifiedData,
                    attributes: [...modifiedData['attributes'], modifiedData.attribute],
                    attribute: initAttribute.current,
                  }));
                }}
                disabled={!enableMapBt}
              >
                + Map
              </Button>
            </div>
          </div>
        </Box>
        {modifiedData['subflowParent'] && modifiedData['throwErrorIfNotFound'] && (
          <TextComponent
            changeHandler={(e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
              const _temp = cloneDeep(modifiedData);
              _temp['errorMessage'] = e.target.value;
              setModifiedData(_temp);
            }}
            data={{
              label: 'Custom Error Message if User Does not Exist',
              value: modifiedData['errorMessage'] ?? '',
            }}
          />
        )}
        {configData.sessionManagement && (
          <SessionManagement
            modifiedData={modifiedData}
            changeHandler={(data: any) => setModifiedData(data)}
            sessionTypes={configData.sessionTypes}
          />
        )}
        <Button
          type="submit"
          fullWidth
          variant="contained"
          sx={{ mt: 3, mb: 2 }}
          onClick={() => {
            closeGritComponent(cloneDeep(modifiedData));
          }}
          disabled={disableSubmit}
        >
          Save
        </Button>
      </FormControl>
    </div>
  );
};

// export default withAITracking(reactPlugin, GenerateAADReadUI);
export default GenerateAADReadUI;
